module.exports = __webpack_public_path__ + "img/Felsenbild.478fc8e3.jpg";